import { ca } from '@cian/analytics';

export const trackShowNewbuildingDecoration = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Finishing',
    action: 'Show_sopr',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
};

interface ITrackClickNewbuildingDecorationParams {
  offerId: number;
  label: string;
  type: string;
}

export const trackClickNewbuildingDecoration = ({ offerId, label, type }: ITrackClickNewbuildingDecorationParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Finishing',
    action: 'click_sopr',
    label,
    page: {
      pageType: 'Card',
      siteType: 'desktop',
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: {
          finishing_type: type,
        },
      },
    ],
  });
};

export const trackPhoneOpen = (label: string) => {
  ca('eventEbc', {
    category: 'Phones',
    action: 'Open_card_decoration_block',
    label,
    useLastProducts: true,
  });
};
